import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { State } from '../../shared/core/state';
import * as UserActions from '../../shared/core/state/users/user.actions';

@Component({
  selector: 'black-account-deletion',
  templateUrl: './account-deletion.component.html',
  styleUrl: './account-deletion.component.css',
  standalone: false,
})
export class AccountDeletionComponent implements OnInit {
  private store = inject<Store<State>>(Store);
  private destroyRef = inject(DestroyRef);

  userEmail = '';
  confirmEmailInput = '';
  isModalOpen = false;

  ngOnInit(): void {
    this.store
      .select((state) => state.users.user)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((user) => {
        if (user) {
          this.userEmail =
            user.profile?.personal?.email || user.email || user.username || '';
        }
      });
  }

  get isEmailMatched(): boolean {
    return this.confirmEmailInput.trim() === this.userEmail.trim();
  }

  openConfirmModal(): void {
    this.confirmEmailInput = '';
    this.isModalOpen = true;
  }

  closeConfirmModal(): void {
    this.isModalOpen = false;
  }

  confirmDelete(): void {
    if (this.isEmailMatched) {
      this.closeConfirmModal();
      this.store.dispatch(UserActions.deleteUserAccount());
    }
  }
}
